import createPermission from 'permissions/createPermission'

export const uploadSchedule = createPermission('remoteInspections.create')
export const markAsViewed = createPermission('remoteInspections.review')
export const schedule = createPermission('remoteInspections.create')
export const initiate = createPermission('remoteInspections.create')
export const cancelSchedule = createPermission('remoteInspections.create')
export const sendEmail = createPermission('remoteInspections.send')